// Saved preset prices use the API int32 format. Version 2 distinguishes this from a finite bound.
export const PRESET_UNBOUNDED_PRICE = 2147483647;
